import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import VisibilitySensor from 'react-visibility-sensor';
import cx from 'classnames';

import Brand from 'models/brand';

import { EMAIL_OPT_IN_IMPRESSION, EMAIL_OPT_IN_CLICK } from 'lib/analytics/events';

import trackEventCreator from 'action-creators/analytics/track-event';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
};

export class MarketingOptIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: false,
    };

    this.onClick = this.onClick.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
  }

  onClick() {
    const selected = !this.state.selected;
    this.setState({ selected });
    this.props.onChange(selected);
    this.props.trackEvent(EMAIL_OPT_IN_CLICK);
  }

  onVisibilityChange(visible) {
    if (visible) {
      this.props.trackEvent(EMAIL_OPT_IN_IMPRESSION);
    }
  }

  render() {
    const { brand, className } = this.props;
    const { selected } = this.state;

    if (!brand.requireMarketingOptIn) { return null; }

    const optInClasses = cx({
      checkbox: true,
      noselect: true,
      selected,
    });

    return (
      <VisibilitySensor onChange={this.onVisibilityChange} partialVisibility>
        <div className={className}>
          <div className={optInClasses} onClick={this.onClick}>
            <label>
              <span className="margin-left-5 text-size-14 text-weight-book text-color-dark-slate">
                <FormattedMessage
                  id="common.marketing-opt-in"
                  defaultMessage="Send me emails with special offers and updates from {brandName}"
                  values={{
                    brandName: brand.displayName,
                  }}
                />
              </span>
            </label>
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    trackEvent: trackEventCreator,
  }, dispatch)
);

const mapStateToProps = (state) => {
  const {
    brand,
  } = state.brand;

  return {
    brand,
  };
};

MarketingOptIn.propTypes = propTypes;
MarketingOptIn.defaultProps = defaultProps;
export default connect(mapStateToProps, mapDispatchToProps)(MarketingOptIn);
